import { render, staticRenderFns } from "./ReportSnapshotGenerate.vue?vue&type=template&id=0bf3a0da&scoped=true"
import script from "./ReportSnapshotGenerate.vue?vue&type=script&lang=js"
export * from "./ReportSnapshotGenerate.vue?vue&type=script&lang=js"
import style0 from "./ReportSnapshotGenerate.vue?vue&type=style&index=0&id=0bf3a0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf3a0da",
  null
  
)

export default component.exports